module.exports = __webpack_public_path__ + "static/media/daylytes_video.0b2cdd88.png";